// extracted by mini-css-extract-plugin
export var addressFields = "_ou-0";
export var animationContainer = "_ou-1";
export var footer = "_ou-2";
export var lineItems = "_ou-3";
export var modalContent = "_ou-4";
export var orderName = "_ou-5";
export var strong = "_ou-6";
export var warning = "_ou-7";